import React from 'react';
import { X } from 'lucide-react';
import { TermsContent } from '../components/LegalContent';

const TermsOfServiceModal = ({ onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center">
    <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}></div>
    <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-hidden">
      <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50">
        <h2 className="text-xl font-bold text-gray-800">서비스 이용약관</h2>
        <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-xl transition-colors duration-200" aria-label="닫기">
          <X className="w-5 h-5 text-gray-600" />
        </button>
      </div>
      <div className="p-6 overflow-y-auto max-h-[60vh]">
        <TermsContent />
      </div>
      <div className="flex items-center justify-between gap-4 p-6 border-t border-gray-200 bg-gray-50">
        <a href="/terms" className="text-sm text-blue-600 hover:text-blue-800 underline">전체 페이지로 보기</a>
        <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors duration-200 text-sm font-medium">
          확인
        </button>
      </div>
    </div>
  </div>
);

export default TermsOfServiceModal;
